module.exports = __webpack_public_path__ + "img/tire_rotation.057493ba.svg";